import { setFeatureToggle } from './featureToggleMutationTypes.js';
import {
  setAllFeatureTogglesForLoggedInUserAction,
  setAllFeatureTogglesForUserAction,
} from './featureToggleActionTypes.js';
import FEATURE_TOGGLE_ENUM from 'shared/featureToggle/FEATURE_TOGGLE_ENUM.js';
import { each, get } from 'lodash';
import { getLoggedInUser } from '../user/userDataGetterTypes.js';
import { getFeatureToggle } from './featureToggleGetterTypes.js';

export default {
  state: {},
  getters: {
    [getFeatureToggle]: (state) => (key) => state[key],
  },
  mutations: {
    [setFeatureToggle](state, { key, value }) {
      state[key] = value;
    },
  },
  actions: {
    [setAllFeatureTogglesForUserAction]({ commit }, user) {
      const backendFlags = get(user, 'client.feature_flags', {});

      each(FEATURE_TOGGLE_ENUM, (featureToggle) => {
        commit(setFeatureToggle, {
          key: featureToggle,
          value: !!backendFlags[featureToggle],
        });
      });
    },
    [setAllFeatureTogglesForLoggedInUserAction]({ dispatch, rootGetters }) {
      dispatch(setAllFeatureTogglesForUserAction, rootGetters[getLoggedInUser]);
    },
  },
};
